module.exports = __webpack_public_path__ + "static/media/treatments.4af61be5.png";